<template>
  <div class="bg-white border border-gray-200 rounded-2xl p-6">
    <h3 class="font-semibold text-[#1E293B] mb-1">Open Demat Account & Apply</h3>
    <p class="text-xs text-[#64748B] mb-4">Open a free demat account to apply for IPOs online</p>
    <div class="space-y-3">
      <a v-for="b in brokers" :key="b.name" :href="b.url" target="_blank" rel="noopener sponsored"
        class="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-[#2563EB] hover:shadow-sm transition">
        <div class="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-sm" :style="{background: b.color}">{{ b.name[0] }}</div>
        <div class="flex-1">
          <div class="text-sm font-medium text-[#1E293B]">{{ b.name }}</div>
          <div class="text-xs text-[#64748B]">{{ b.tag }}</div>
        </div>
        <span class="text-xs bg-[#2563EB] text-white px-3 py-1.5 rounded-lg font-medium">Open Free</span>
      </a>
    </div>
    <p class="text-[10px] text-[#94A3B8] mt-3 text-center">* Affiliate links. We may earn commission at no cost to you.</p>
  </div>
</template>

<script setup>
const brokers = [
  { name: 'Zerodha', tag: '₹0 Account • ₹20/trade', color: '#387ED1', url: 'https://zerodha.com/open-account?c=NAVYA' },
  { name: 'Groww', tag: '₹0 Account • Free IPO Apply', color: '#00D09C', url: 'https://groww.in/open-demat-account' },
  { name: 'Upstox', tag: '₹0 Account • ₹20/trade', color: '#6C3EF5', url: 'https://upstox.com/open-account/' },
  { name: 'Angel One', tag: '₹0 Account • Free Delivery', color: '#FF6600', url: 'https://www.angelone.in/open-demat-account' },
  { name: '5paisa', tag: '₹0 Account • ₹20/trade', color: '#014B8F', url: 'https://www.5paisa.com/open-demat-account' },
];
</script>
